/* tslint:disable */
/* eslint-disable */

import { ReaderInlineDataFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type useIsOnline_seller = {
    readonly presence: {
        readonly recentOnlineDate: string | null;
    } | null;
    readonly " $refType": "useIsOnline_seller";
};
export type useIsOnline_seller$data = useIsOnline_seller;
export type useIsOnline_seller$key = {
    readonly " $data"?: useIsOnline_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"useIsOnline_seller">;
};



const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useIsOnline_seller"
};
(node as any).hash = '97fff3f2785195fc10b766a7aae43472';
export default node;
